import React from "react";
import DetailsComponent from "./DetailsComponent";

const DetailsContainer = ({ setTicket }) => {
  return <DetailsComponent setTicket={setTicket} />;
};

export default DetailsContainer;
